var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.ready
    ? _c(
        "w-container",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c(
                    "w-row",
                    { attrs: { "no-margin": "" } },
                    [
                      _c(
                        "w-button",
                        {
                          attrs: { flat: "" },
                          on: {
                            click: function ($event) {
                              return _vm.goToDossier()
                            },
                          },
                        },
                        [_c("w-fa", { attrs: { icon: "arrow-left" } })],
                        1
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button-bar",
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "Condities instellen",
                                  expression: "'Condities instellen'",
                                },
                              ],
                              on: {
                                click: function ($event) {
                                  return _vm.editConditions()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "filter" } })],
                            1
                          ),
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: "Opslaan",
                                  expression: "'Opslaan'",
                                },
                              ],
                              attrs: {
                                disabled:
                                  _vm.saving || !_vm.ready || !_vm.valid,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.save()
                                },
                              },
                            },
                            [_c("w-fa", { attrs: { icon: "save" } })],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            { attrs: { grow: "", shrink: "" } },
            [
              _c(
                "w-col",
                { style: { height: "100%" }, attrs: { xs: "12", grow: "" } },
                [
                  _c("app-dossier-auto-sale-row-setting-edit", {
                    attrs: { setting: _vm.setting },
                    on: {
                      valid: function ($event) {
                        _vm.valid = $event
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.conditionsModalOpen
            ? _c(
                "w-modal",
                { attrs: { value: "", "full-height": "" } },
                [
                  _c("app-dossier-auto-sale-row-setting-edit-conditions", {
                    attrs: { "sale-types": _vm.saleTypes },
                    on: {
                      close: function ($event) {
                        _vm.conditionsModalOpen = false
                      },
                    },
                    model: {
                      value: _vm.setting,
                      callback: function ($$v) {
                        _vm.setting = $$v
                      },
                      expression: "setting",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }